import { render } from "./ReportsPanel.vue?vue&type=template&id=15957a27&scoped=true&ts=true"
import script from "./ReportsPanel.vue?vue&type=script&lang=ts"
export * from "./ReportsPanel.vue?vue&type=script&lang=ts"

import "./ReportsPanel.vue?vue&type=style&index=0&id=15957a27&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15957a27"]])

export default __exports__